<template>
  <div class="burger">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<style lang="scss" scoped>
.burger {
  width: var(--navbar-height);
  height: var(--navbar-height);
  background-color: var(--primary-500);
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: var(--primary-600);
  }
  &:active {
    background-color: var(--primary-700);
  }
  @media screen and (max-width: 1104px) {
    padding: 17px
  }
}

.burger span {
  display: block;
  width: 100%;
  height: 4px;
  background-color: white;
  border-radius: 8px;
  @media screen and (max-width: 1104px) {
    height: 3px;
  }
  &:nth-child(2) {
    margin: 5px 0;
    @media screen and (max-width: 1104px) {
      margin: 3px 0;
    }
  }
}



</style>